export default function RadioOutlineIcon() {
  return (
    <>
      <circle cx='8' cy='8' r='7.25' />
    </>
  );
}
